import { render, staticRenderFns } from "./CertificatesListFilters.vue?vue&type=template&id=52a95b45&"
import script from "./CertificatesListFilters.vue?vue&type=script&lang=js&"
export * from "./CertificatesListFilters.vue?vue&type=script&lang=js&"
import style0 from "./CertificatesListFilters.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports